<template>
  <div>
    <!-- Loading Spinner -->
    <div v-if="loading" class="d-flex justify-content-center align-items-center vh-100">
      <div class="spinner-border" role="status"></div>
    </div>

    <!-- Exam List Card -->
    <div v-else class="container py-5">
      <div class="d-flex justify-content-center" v-if="scoredetails.length > 0">
        <div class="card shadow-lg rounded-4 p-2 w-100">
          <div class="card-header bg-white d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Score Obtained</h4>
            <button class="print-btn" @click="printCertificate">
                 Show Certificate
                </button>
            <button class="btn btn-outline-secondary btn-sm" @click="goBack">Back</button>
          </div>

          <div class="card-body">

        <div class="result-wrapper" v-if="scoredetails && scoredetails.length">

    <!-- Result Summary (sirf ek baar) -->
    <div class="result-summary">
        <h5>Result Summary</h5>
        <div><strong>Student:</strong> {{ scoredetails[0].student_name }}</div>
        <div><strong>Exam:</strong> {{ scoredetails[0].exam_name }}</div>
        <div><strong>Exam Type:</strong> {{ scoredetails[0].exam_type_name }}</div>
        <div><strong>Subject:</strong> {{ scoredetails[0].subject_name }}</div>
    </div>

    <!-- Question Wise Result (MULTIPLE ROWS) -->
    <div
        v-for="(q, index) in scoredetails"
        :key="q.id"
        class="result-card"
    >

        <div class="question">
        <strong>Q{{ index + 1 }}.</strong> {{ q.questiontype }}
        </div>

        <div class="answers">
        <div><strong>Your Answer:</strong> {{ q.selected }}</div>
        <div><strong>Correct Answer:</strong> {{ q.answer }}</div>
        </div>

        <div class="result-footer">
        <span
            class="status"
            :class="q.correct_flag == 1 ? 'correct' : 'wrong'"
        >
            {{ q.correct_flag == 1 ? 'Correct' : 'Wrong' }}
        </span>

        <span class="marks">
            Marks: {{ q.correct_flag == 1 ? q.marks : 0 }}
        </span>
        </div>

    </div>



 <div class="total-summary">
    <div>
      <strong>Total Marks:</strong>
      {{
        scoredetails.reduce((sum, q) => sum + Number(q.marks), 0)
      }}
    </div>

    <div>
      <strong>Obtained Marks:</strong>
      {{
        scoredetails.reduce(
          (sum, q) => sum + (q.correct_flag == 1 ? Number(q.marks) : 0),
          0
        )
      }}
    </div>
  </div>










    </div>





                <div>
                </div>













          </div>

        </div>
      </div>

      <div v-else>
        <span class="text-center text-danger">*No Result Found</span>
        </div>

    </div>
  </div>

  
</template>

<script> 
import axios from "@/plugins/axios";   

export default {
  name: 'newsession',
  mounted() { 

    if(this.$route.query.id){
    this.getSessions(this.$route.query.id);
    this.examtypeid = this.$route.query.id;
    }else{
         this.getSessions();
    }
  },
  data() {
    return {
      loading: true,
      scoredetails: [],
      examtypeid:'',
      studentId: this.$route.query.student_id,
    };
  },
  methods: {
    
    goBack() {
      this.$router.go(-2);
    },

    async getSessions(id) {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;


        axios.post("getscoreadmin", { id: id }).then((response) => {

          self.scoredetails = response.data.scoredetails;
   

        }).then(() => {
          


        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

     printCertificate() {
        var self = this;
              self.$router.push(`/showcertificationadminView?id=${self.examtypeid}`);
        }






  }
}
</script>

<style scoped>
.card {
  border-radius: 16px;
}
table th {
  font-weight: 600;
}
table td {
  font-size: 15px;
}
@media (max-width: 600px) {
  table td {
    font-size: 13px;
  }
}


/* ===== Wrapper ===== */
.certificate-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #f4f6f8;
}

/* ===== Certificate Card ===== */
.certificate {
  width: 148mm;
  min-height: 210mm;
  background: #ffffff;
  padding: 25px;
  border: 6px double #2c3e50;
  font-family: "Times New Roman", serif;
  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
}

/* ===== Header ===== */
.cert-header {
  text-align: center;
}

.cert-header h2 {
  margin: 0;
  font-size: 22px;
  font-weight: bold;
}

.cert-header h4 {
  margin-top: 8px;
  font-weight: normal;
}

.cert-line {
  width: 60%;
  height: 2px;
  background: #2c3e50;
  margin: 10px auto;
}

/* ===== Body ===== */
.cert-body {
  text-align: center;
  margin-top: 35px;
  font-size: 16px;
}

.student-name {
  margin: 15px 0;
  font-size: 22px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.exam-name {
  margin: 10px 0;
  font-size: 18px;
}

.exam-type {
  font-style: italic;
  color: #555;
}

.subject,
.marks {
  margin-top: 12px;
}

/* ===== Footer ===== */
.cert-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
}

.sign-line {
  width: 120px;
  border-top: 1px solid #000;
  margin-bottom: 5px;
}

.cert-footer span {
  font-size: 14px;
}

.cert-date {
  text-align: center;
  margin-top: 25px;
  font-size: 14px;
}

/* ===== Mobile Responsive ===== */
@media (max-width: 768px) {
  .certificate {
    width: 100%;
    min-height: auto;
    padding: 18px;
  }

  .cert-header h2 {
    font-size: 18px;
  }

  .student-name {
    font-size: 18px;
  }

  .cert-body {
    font-size: 14px;
  }

  .cert-footer {
    margin-top: 40px;
  }
}

/* ===== Print ===== */
@media print {
  body {
    background: #fff;
  }

  .certificate-wrapper {
    padding: 0;
  }

  .certificate {
    box-shadow: none;
    border: 4px solid #000;
  }
}

.print-btn {
  background: #2c3e50;
  color: #fff;
  border: none;
  padding: 10px 18px;
  font-size: 14px;
  border-radius: 4px;
  cursor: pointer;
}

.print-btn:hover {
  background: #1a252f;
}

/* ===== PRINT ONLY CERTIFICATE ===== */
@media print {

  /* Hide everything */
  body * {
    visibility: hidden;
  }

  /* Show only certificate */
  .certificate-wrapper,
  .certificate-wrapper * {
    visibility: visible;
  }

  /* Position certificate properly */
  .certificate-wrapper {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    padding: 0;
    background: white;
  }

  /* Remove card & container look */
  .card,
  .card-header,
  .card-body,
  .container {
    border: none !important;
    box-shadow: none !important;
    padding: 0 !important;
    margin: 0 !important;
  }

  /* Hide buttons */
  .print-btn,
  .btn {
    display: none !important;
  }

  /* Certificate clean print */
  .certificate {
    width: 148mm;
    min-height: 210mm;
    border: 2px solid #000;
    box-shadow: none;
  }
}

.result-wrapper {
  margin-top: 15px;
  font-family: Arial, sans-serif;
}

.result-summary {
  background: #f8f9fa;
  border-left: 5px solid #2c3e50;
  padding: 15px;
  margin-bottom: 20px;
  border-radius: 6px;
}

.result-summary h5 {
  margin-bottom: 10px;
  font-weight: bold;
}

.result-card {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 15px;
  background: #fff;
}

.question {
  font-size: 16px;
  margin-bottom: 10px;
}

.answers {
  margin-left: 10px;
  font-size: 14px;
  color: #333;
}

.answers div {
  margin-bottom: 4px;
}

.result-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
}

.status {
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
}

.status.correct {
  background: #28a745;
}

.status.wrong {
  background: #dc3545;
}

.marks {
  font-weight: bold;
  font-size: 14px;
}

/* Mobile */
@media (max-width: 768px) {
  .question {
    font-size: 15px;
  }

  .answers {
    font-size: 13px;
  }

  .result-footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .marks {
    font-size: 13px;
  }
}


.total-summary {
  margin-top: 20px;
  padding: 15px;
  border-top: 2px solid #2c3e50;
  display: flex;
  justify-content: space-between;
  font-size: 15px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .total-summary {
    flex-direction: column;
    gap: 6px;
    font-size: 14px;
  }
}









</style>
